import {i18n} from '@online-offer/i18n';
import {Show} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {RichTextDisplay} from '../../components/RichTextDisplay/RichTextDisplay';
import {SectionPrint} from '../../components/SectionPrint/SectionPrint';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';

export function AdvertisementDescriptionPrint() {
  const {advertisementDescription} = useGetOnlineOfferData();

  return (
    <Show when={isNotNilOrEmpty(advertisementDescription)}>
      <SectionPrint heading={i18n.t('details.sellerDescription')}>
        <RichTextDisplay html={advertisementDescription!} />
      </SectionPrint>
    </Show>
  );
}
